import { AccountInfoRoot } from "./account-info";
import { AccountInfoDefaultAddress } from "./account-info-default-address";
import { AccountInfoDefaultContact } from "./account-info-default-contact";
import { AccountInfoDeleteAccount } from "./account-info-delete-account";
import { AccountInfoDetails } from "./account-info-details";

export const AccountInfo = Object.assign(AccountInfoRoot, {
  Details: AccountInfoDetails,
  DefaultContact: AccountInfoDefaultContact,
  DefaultAddress: AccountInfoDefaultAddress,
  DeleteAccount: AccountInfoDeleteAccount,
});

export type { AccountInfoProps } from "./types";
